import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({ name: 'safeUrl' })
export class SafeUrlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(url: string): SafeResourceUrl {
    const encodedUrl = encodeURIComponent(url);
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://docs.google.com/viewerng/viewer?embedded=true&url=${encodedUrl}`
    );
  }
}
